// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__HeAut","emails":"CreateEditClinics_emails__JFVh3","emailTagLabel":"CreateEditClinics_emailTagLabel__2dJa4"};